import { UserManagementState, UserDetails } from "./types";

export function getDefaultState(): UserManagementState {
	return {
		userList: Array<UserDetails>(),
		permissions: [],
		userRoles: [],
		userDomains: [],
		domains: [],
		domainGroups: [],
		userGroups: [],
		contacts: [],
		contactRoles: [],
		pageIndex: 1,
		pageSize: 25,
		allUsersRetrieved: false,
		userTableIsBusy: true,
		includeBlankUsernames: false,
		domainModal: {
			domainId: 0,
			shown: false
		}
	};
}
